import React, { ButtonHTMLAttributes, InputHTMLAttributes } from 'react'
import { IBaseProps, IBasePropsWithSlots } from '@did/types'
import { IMainChain } from '.'

export interface IConfontProps extends IBaseProps {
  name?: string
  color?: string
  size?: number | string
  rounded?: boolean
}

export type IconfontType = React.FC<IConfontProps>

export interface IButtonProps
  extends IBasePropsWithSlots,
    ButtonHTMLAttributes<HTMLButtonElement> {
  block?: boolean
  loading?: boolean
  done?: boolean
  primary?: boolean
  solid?: boolean
  small?: boolean
  defaultLoading?: boolean
  middle?: boolean
  large?: boolean
  to?: string
  href?: string
  target?: string
  disabled?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  slots: {
    icon: IconfontType
  }
}

export type ButtonType = React.FC<IButtonProps>

export interface ILinkProps extends IBaseProps {
  to?: string
}

export type LinkType = React.FC<ILinkProps>

export interface BaseListItemProps extends IBaseProps {
  onClick?: () => void
  to?: string
  plain?: boolean
  children?: React.ReactNode
  head?: React.ReactNode
  tail?: React.ReactNode
}

export type BaseListItemType = React.FC<BaseListItemProps>

export interface WireframeProps extends IBaseProps {
  shape?: 'rect' | 'circle' | 'round'
  height?: number | string
  width?: number | string
}

export type WireframeType = React.FC<WireframeProps>

export interface AccountInputValueParam {
  value: string
  address: string
}
export interface IAccountInputProps extends IBasePropsWithSlots {
  slots: {
    icon: IconfontType
  }
  placeholder?: string
  errorMessages?: string[]
  chain: IMainChain
  name: string
  type?: string
  top?: boolean
  onInput?: (val: string) => void
  onChange?: (val: AccountInputValueParam) => void
}

export type AccountInputType = React.FC<IAccountInputProps>

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  value?: string | number
  type?: string
  suffix?: string
  errorMessages?: string[]
}

export type TextInputType = React.FC<TextInputProps>

export interface IBaseListPagerProps extends IBasePropsWithSlots {
  pages: number
  current: number
  noItems?: boolean
  onChange: (page: number) => void
  slots: {
    icon: IconfontType
  }
}

export type BaseListPagerType = React.FC<IBaseListPagerProps>

export interface IConnectWalletProps extends IBasePropsWithSlots {
  slots: {
    button: ButtonType
    icon: IconfontType
  }
  chainIconName: string
  address: string
  onClick?: () => void
  empty?: React.ReactNode
  bitName?: string
}

export type ConnectWalletType = React.FC<IConnectWalletProps>

export interface INotFoundProps extends IBaseProps {
  title?: string
  iconName?: string
}

export type NotFoundType = React.FC<INotFoundProps>

export interface IRecordStatusFilterOption {
  label: string
  value: any
}

export enum EnumRecordStatusFilters {
  all = '',
  topUp = 'deposit',
  withdraw = 'withdraw',
  expenditures = 'transfer'
}

export interface IRecordStatusFilter extends IBaseProps {
  value?: string | number
  options: IRecordStatusFilterOption[]
  onInput: (value: EnumRecordStatusFilters) => void
}

export type RecordStatusFilterType = React.FC<IRecordStatusFilter>
